import {motion} from "framer-motion";
import {Spin} from "antd";

const FullLoading = () => {
    return (
        <div className="flex h-screen w-screen flex-col items-center justify-center gap-2">
            <div className="w-20">
                <img src="/logo.png" alt="logo" className="rounded-full"/>
            </div>

            <div className="font-bold">{'در حال دریافت اطلاعات ...'}</div>
            <motion.div animate={{opacity: [1, 0.5, 1]}} transition={{repeat: Infinity}}>
                <div>{'لطفا کمی صبر کنید'}</div>
            </motion.div>
            <Spin spinning={true} size={'large'}/>
        </div>
    );
};

export default FullLoading;
